import { useMemo } from "react";
import { useSelector } from "react-redux";

const useFinancePermissions = () => {
  const user = useSelector((state) => state.auth.user);

  const permissions = useMemo(() => {
    return user?.financeAdminRole?.permissions || null;
  }, [user]);

  const canView = (moduleKey) => {
    const p = permissions?.[moduleKey];
    return p?.canView === true || p?.canEdit === true;
  };

  const canEdit = (moduleKey) => {
    const p = permissions?.[moduleKey];
    return p?.canEdit === true;
  };

  return {
    permissions,
    canView,
    canEdit,
  };
};

export default useFinancePermissions;

